import Axios from 'axios';

const server = process.env.REACT_APP_SERVER_URL;

export interface AuditMovementFilters {
  email?: string;
  day?: Date;
  ip?: string;
  endpoint?: string;
}

export interface AuditMovementRecord {
  id_log: number;
  id_usuario: number;
  fecha: string;
  ip: string;
  params?: string;
  body?: Object;
  id_descripcion?: number;
  descripcion?: string;
  nombre_completo: string;
  nombre_de_usuario: string;
  direccion: string;
  cedula: string;
  nacionalidad: string;
  id_tipo_usuario: number;
  telefono: string;
  id_contribuyente: number | null;
  verificado: boolean;
  bloqueado: boolean;
  cargo?: string;
}

export interface AuditMovementsResponse {
  logs: AuditMovementRecord[];
  logsTotal: number;
  message: string;
  status: number;
}

export interface AuditMovementDescription {
  id_descripcion: number;
  endpoint: string;
  metodo: string;
  descripcion: string;
}

export const getAuditMovements = async (
  page: number = 1,
  token: string,
  filters: AuditMovementFilters = {}
): Promise<AuditMovementsResponse> => {
  try {
    const response = await Axios.post(`${server}/branches/logs/${page}`, filters, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return {
      logs: response.data?.data?.logs || [],
      logsTotal: response.data?.data?.logsTotal || 0,
      message: response.data?.data?.message || '',
      status: response.data?.data?.status || 0,
    };
  } catch (error) {
    throw error;
  }
};

export const getAuditMovementDescriptions = async (token: string): Promise<AuditMovementDescription[]> => {
  try {
    const response = await Axios.get(`${server}/branches/logs/descripciones`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    return response.data?.data?.descriptions || [];
  } catch (error) {
    throw error;
  }
};
